import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { FailureRating } from "@coworker/apprestructured/src/shared/components/FailureRating/FailureRating";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { getSchemaForTaskPath } from "@coworker/apprestructured/src/shared/helpers/task.helper";
import {
  CRITERION_KEYS,
  type FailedCriteriaItem,
} from "@coworker/apprestructured/src/task-management/types/TestBuy";

export type FailedCriteriaSummaryCreatorFragmentConfigProps = {
  field: string;
};

type FailedCriteriaSummaryCreatorFragmentProps = {
  configProps: FailedCriteriaSummaryCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function FailedCriteriaSummaryCreatorFragment({
  configProps,
  commonProps,
}: FailedCriteriaSummaryCreatorFragmentProps) {
  const { task, taskType } = commonProps;
  const { field } = configProps;

  if (isLoading(task)) {
    return <LoadingCreatorFragment />;
  }

  const criteriaData = getByPath(task, field) as
    | FailedCriteriaItem[]
    | undefined;

  if (!criteriaData || criteriaData.length === 0) {
    return null;
  }

  const maxCriteria =
    getSchemaForTaskPath(taskType, field)?.maxItems || CRITERION_KEYS.length;
  const failedCriteria = criteriaData.filter((item) => !item.completed).length;

  return (
    <div style={{ padding: "16px 24px 0 24px" }}>
      <FailureRating
        maxCriteria={maxCriteria}
        failedCriteria={failedCriteria}
        message="criteriaFailedString"
      />
    </div>
  );
}

export default FailedCriteriaSummaryCreatorFragment;
